import { Badge } from "@elaniintc/goes-design-system";
import ValueDisplay from "./value-display";
import type { RenderProps } from "./types";

const documentTypeLabel = (type: string | undefined): string =>
  type === "passport" ? "PASAPORTE" : (type ?? "").toUpperCase();

/**
 * El tipo de documento ya no va entre parentesis delante del valor: el diseno
 * lo pide como chip alineado a la derecha de la celda, separado del numero.
 */
function withDocumentType(
  label: string,
  value: string,
  isOldValue?: boolean,
) {
  return (
    <div className="flex w-full items-center gap-2 min-w-0">
      <div className="min-w-0 flex-1">
        <ValueDisplay isOldValue={isOldValue}>{value}</ValueDisplay>
      </div>
      {label && (
        <Badge variant="neutral" shape="pill" fill="ghost" size="sm">
          {label}
        </Badge>
      )}
    </div>
  );
}

export default function duiNitRenderer({
  value,
  isOldValue,
  obj,
}: RenderProps) {
  if (obj.config?.allow_select_document_type) {
    if (typeof value === "string" && value !== "") {
      return withDocumentType(
        documentTypeLabel(obj.config.document_type),
        value,
        isOldValue,
      );
    }
  }

  if (typeof value === "string" && value !== "") {
    return <ValueDisplay isOldValue={isOldValue}>{value}</ValueDisplay>;
  }

  const duiNITValue = value as { type: string; value: string } | undefined;
  if (!duiNITValue?.value) {
    return <span className="text-on-disabled-quiet">Vacío</span>;
  }
  return withDocumentType(
    documentTypeLabel(duiNITValue.type),
    duiNITValue.value,
    isOldValue,
  );
}
